import React from "react";
import { CV } from "../components/cv";
import PhilipPImg from "@/assets/images/philip-p.png";

export default function CVPhilipPersson() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Philip Persson";
  }, []);

  return (
    <CV
      name="Philip Persson"
      title="Developer"
      subtitle="Full-stack .NET and React development — background at Knowit, Resurs Bank and Omegapoint"
      photo={PhilipPImg}
      summary="Passionate developer who thrives on collaboration and building great applications. A knack for bridging frontend and backend working with .NET, Node.js, React, Next.js, and their related technologies. Committed to writing clean, maintainable code and delivering quality software."
      skills={{
        "Languages": [".NET", "C#", "TypeScript", "JavaScript"],
        "Frontend": ["React", "Next.js"],
        "Backend": ["Node.js", "REST APIs", "SQL"],
        "Cloud": ["Azure"],
        "Methods": ["Full-stack Development", "Agile Development"],
      }}
      experience={[
        {
          role: "Developer",
          company: "BoldBrave",
          period: "Feb 2025 – Present",
          description:
            "Full-stack development with focus on modern web technologies, building scalable and maintainable applications.",
          highlights: [
            "Develop full-stack applications using .NET and React/Next.js",
            "Design and implement RESTful APIs",
            "Build responsive and performant user interfaces",
            "Collaborate with designers and stakeholders to deliver quality solutions",
          ],
        },
        {
          role: "Senior Developer (Consultant)",
          company: "Omegapoint",
          period: "Jan 2023 – Apr 2025",
          description:
            "Senior consulting developer delivering client projects with focus on quality and modern development practices.",
        },
        {
          role: "Senior Frontend Developer (Consultant)",
          company: "Avensia",
          period: "Aug 2021 – Nov 2022",
          description:
            "Frontend consulting focused on e-commerce solutions and modern web development.",
        },
        {
          role: "Senior Frontend Developer",
          company: "Resurs Bank",
          period: "Nov 2020 – Sep 2021",
          description:
            "Frontend development for banking and financial services applications.",
        },
        {
          role: "Lead Frontend Developer & UI/UX Designer",
          company: "Knowit",
          period: "Oct 2015 – Nov 2020",
          description:
            "Led frontend development and contributed to UI/UX design across client projects over five years.",
        },
      ]}
      education={[
        {
          degree: "Computer Science / Software Development",
          institution: "Malmö University",
          year: "2011 – 2014",
        },
      ]}
    />
  );
}
